module.exports = __webpack_public_path__ + "img/pear-manhattan.386a937d.jpg";